export default "__VITE_ASSET__8141cee5__"